import { render, staticRenderFns } from "./soanvanban.vue?vue&type=template&id=359b0308&scoped=true&"
import script from "./soanvanban.vue?vue&type=script&lang=js&"
export * from "./soanvanban.vue?vue&type=script&lang=js&"
import style0 from "./soanvanban.vue?vue&type=style&index=0&id=359b0308&scoped=true&lang=css&"
import style1 from "./soanvanban.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359b0308",
  null
  
)

export default component.exports